import { IoIosMail } from 'react-icons/io';
import styled from '@emotion/styled';
import Router from 'next/router';
import { DARK_GRAY } from '../../../styles/constants/color';

const Button = styled.button`
  width: auto;
  height: auto;
  text-align: center;
`;

interface Props {
  color?: string;
}

/**
 *  쏠카 문의 링크 버튼 컴포넌트
 * @param {string} color 버튼의 색깔 defalut: #666;
 *  */
function ScInquiry({ color }: Props): JSX.Element {
  const onClick = (): void => {
    Router.push('https://solecar.co.kr/footer_contact_email');
  };

  return (
    <Button onClick={onClick}>
      <IoIosMail size={33} color={color || DARK_GRAY} />
    </Button>
  );
}

export default ScInquiry;
